<template>
  <!--suppress JSUnresolvedVariable -->
  <button class="-button" @click="emitClick($event)"
  ><i :class="[iconClassName, 'margin-right-4']"></i>{{value}}</button>
</template>

<script>
export default {
  name: 'button-delete',
  props: {
    value: {
      type: String,
      default: '删除'
    },
    iconClassName: {
      type: String,
      default: 'el-icon-delete'
    }
  }
}
</script>

<style scoped lang="less">
  @import "../styles/fun_var";

  .-button {
    min-width: 90px;
    height: 32px;
    font-size: 13px;
    .generate-common-button(#F7F7F7, #F25721)
  }
</style>



// WEBPACK FOOTER //
// src/components/common/buttons/button-delete.vue